import { api } from "../../services/jobtypes.service";
import { useRelationshipCheck } from "./useRelationshipCheck";

export const useFormVersionRelationshipCheck = (id: string) =>
  useRelationshipCheck(id, api.checkFormVersionRelationships);
